/**
 * Created by why on 2019/10/21.
 */
import {
  getMessageDetailByCondition,
  messageDetailSave,
  messageDetailEdit,
  messageDetailDelByIds,
  getByStatusPage
} from '@/api/message-detail-manage'

export default {
  state: {
    list: [],
    Loading: false,
    loadingSave: false,
    pageSize: 10,
    pageNum: 1,
    total: 0,
    infoList: [],
    infoPageSize: 10,
    infoPageNum: 1,
    infoTotal: 0,
    infoLoading: false
  },
  mutations: {
    setMessageDetailList (state, list) {
      state.list = list
    },
    setMessageDetailLoading (state, loading) {
      state.Loading = loading
    },
    setMessageDetailPageSize (state, pageSize) {
      state.pageSize = pageSize
    },
    setMessageDetailPageNum (state, pageNum) {
      state.pageNum = pageNum
    },
    setMessageDetailTotal (state, total) {
      state.total = total
    },
    setMessageDetailLoadingSave (state, loadingSave) {
      state.loadingSave = loadingSave
    },
    setMessageInfo (state, {list, pageSize, pageNum, total}) {
      state.infoList = list
      state.infoPageNum = pageNum
      state.infoPageSize = pageSize
      state.infoTotal = total
    },
    setInfoLoading (state, loading) {
      state.infoLoading = loading
    }
  },
  getters: {
    messageDetailList: state => state.list,
    messageDetailTotal: state => state.total,
    messageDetailLoading: state => state.Loading,
    messageDetailLoadingSave: state => state.loadingSave,
    messageInfoLoading: state => state.infoLoading,
    infoTotal: state => state.infoTotal,
    infoList: state => state.infoList
  },
  actions: {
    getMessageDetailByCondition ({ state, commit }, data) {
      commit('setMessageDetailLoading', true)
      return new Promise((resolve, reject) => {
        getMessageDetailByCondition(data).then(res => {
          const data = res.data.result
          const list = data.records
          const pageSize = data.pageSize
          const pageNum = data.pageNum
          const total = data.total
          commit('setMessageDetailList', list)
          commit('setMessageDetailLoading', false)
          commit('setMessageDetailPageSize', pageSize)
          commit('setMessageDetailPageNum', pageNum)
          commit('setMessageDetailTotal', total)
          resolve(res)
        }).catch(err => {
          commit('setMessageDetailLoading', false)
          reject(err)
        })
      })
    },
    getByStatusPage ({ state, commit }, data) {
      commit('setInfoLoading', true)
      return new Promise((resolve, reject) => {
        getByStatusPage(data).then(res => {
          const data = res.data.result
          const list = data.records
          const pageSize = data.pageSize
          const pageNum = data.pageNum
          const total = data.total
          commit('setMessageInfo', {list, pageSize, pageNum, total})
          commit('setInfoLoading', false)
          resolve(res)
        }).catch(err => {
          commit('setInfoLoading', false)
          reject(err)
        })
      })
    },
    messageDetailSave ({ state, commit }, data) {
      commit('setMessageDetailLoadingSave', true)
      return new Promise((resolve, reject) => {
        messageDetailSave(data).then(res => {
          commit('setMessageDetailLoadingSave', false)
          resolve(res)
        }).catch(err => {
          commit('setMessageDetailLoadingSave', false)
          reject(err)
        })
      })
    },
    messageDetailDelByIds ({ state, commit }, ids) {
      return new Promise((resolve, reject) => {
        messageDetailDelByIds(ids).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    messageDetailEdit ({ state, commit }, data) {
      commit('setMessageDetailLoadingSave', true)
      return new Promise((resolve, reject) => {
        messageDetailEdit(data).then(res => {
          commit('setMessageDetailLoadingSave', false)
          resolve(res)
        }).catch(err => {
          commit('setMessageDetailLoadingSave', false)
          reject(err)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/message-detail-manage.js